import { useEffect, useMemo, useState } from 'react';
import { getFirestore } from 'firebase/firestore';
import { subscribeTourInvitesForTour } from '../utils/tourInviteService';
import { loadEnrichedTourPartyMembers } from '../utils/tourPartyMemberUtils';

/**
 * @param {{ ownerId?: string, ownerName?: string, ownerEmail?: string, ownerPhotoURL?: string, tourId?: string }} params
 */
export function useTourPartyMembers({ ownerId, ownerName, ownerEmail, ownerPhotoURL, tourId }) {
  const [invites, setInvites] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!ownerId || !tourId) {
      setInvites([]);
      return undefined;
    }
    const db = getFirestore();
    const unsub = subscribeTourInvitesForTour(db, ownerId, tourId, (rows) => {
      setInvites(rows || []);
    });
    return unsub;
  }, [ownerId, tourId]);

  useEffect(() => {
    if (!ownerId || !tourId) {
      setMembers([]);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    loadEnrichedTourPartyMembers({
      ownerId,
      ownerName,
      ownerEmail,
      ownerPhotoURL,
      invites,
    })
      .then((rows) => {
        if (!cancelled) setMembers(rows);
      })
      .catch((err) => {
        console.error('useTourPartyMembers enrich', err);
        if (!cancelled) setMembers([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [ownerId, ownerName, ownerEmail, ownerPhotoURL, tourId, invites]);

  const inviteMembers = useMemo(
    () => members.filter((member) => member.inviteId),
    [members]
  );

  return { members, inviteMembers, invites, loading };
}
